<template>
    <div class="library_filter_section">
        <input type="checkbox" id="chapter" class="library-filter-show-hide-input hidden">
        <label class="library-filter-label" for="chapter">Filter by chapter</label>
        <div class="library_filter_items">
            <div class="library_filter_item">
                <library-filter-button :item-id="'global'" :item-value="0" :item-title="nameForGlobal"  @updated="update"></library-filter-button>
            </div>
            <div v-for="chapter in chapters" :key="chapter.id" class="library_filter_item">
                <library-filter-button :item-id="chapter.slug" :item-value="chapter.id" :item-title="chapter.shortName" @updated="update"></library-filter-button>
            </div>
            <div class="library_filter_item flex_fix"></div>

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            checkedChapters: [],
        }
    },
    props: {
        chapters: {
            required: true,
            type: Array,
        },
        nameForGlobal: {
            required: true,
            type: String
        },

    },
    methods: {
        update(payload) {
            this.checkedChapters = this.checkedChapters.filter(el => el != payload.item);
            if (payload.active) { this.checkedChapters.push(payload.item); }
            this.$emit('chaptersChanged', this.checkedChapters);
        }
    }

}
</script>

